import React from 'react';
import * as _ from 'lodash';
import { messageUtility } from '../utilities/messageUtility';

/**
 * @description スクロールで追加ロードを行うコンポーネント
 * @prop {Number} margin
 * @prop {Function} callback
 * @prop {String} targetId スクロールする要素
 * @prop {boolean} isScrollWithBody: handle height body when scroll down
 */
export default class InfinityScrollLoad extends React.Component {
  constructor(props) {
    super(props);

    this.margin = props.margin || 60;
    this.isScrollWithBody = props.isScrollWithBody || false;

    this.state = {
      is_load: false,
    };

    const num = Math.floor(Math.random() * 100000);

    this.ID = `infinity-scroll-div-element ${num}`;
    this.is_remove = false;
    this.removeScrollEvent = () => {};
    this.isSetCallbackCompleted = false;
  }

  componentDidMount() {
    this.setCallback();
  }

  componentDidUpdate() {
    if (!this.isSetCallbackCompleted) {
      // componentDidMount時点でレンダリングされていないのか
      // document.getElementById(this.props.targetId)で取得できない場合がある
      this.setCallback();
    }
  }

  componentWillUnmount() {
    this.removeScrollEvent();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.reset && this.is_remove) {
      this.setCallback();
    }
  }

  setCallback() {
    if (_.isString(this.props.targetId)) {
      const target = document.getElementById(this.props.targetId);
      const callback = this.scrollCallBack.bind(this);

      if (!target) {
        return;
      }

      //console.log("infinity scroll Load DidMount", target , this.ID );

      // イベント登録する
      target.addEventListener('scroll', callback);
      this.removeScrollEvent = () => {
        console.log('Remove scroll load events.');
        this.is_remove = true;
        target.removeEventListener('scroll', callback);
      };

      this.is_remove = false;
      this.isSetCallbackCompleted = true;
    }
  }

  scrollCallBack() {
    const listWrapper = document.getElementById(this.props.targetId);
    const scrollBottom = document.getElementById(this.ID);
    if (listWrapper && scrollBottom) {
      const listWrapperRect = listWrapper.getBoundingClientRect();
      let scrollBottomTop =
        scrollBottom.getBoundingClientRect().top - listWrapperRect.top;
      scrollBottomTop = parseInt(scrollBottomTop, 10);
      this.margin = 0;
      //console.log("top:::",(window.innerHeight - this.margin) ,">" , top );

      let height = undefined;
      if (scrollBottom.parentNode.nodeName === 'UL' || this.isScrollWithBody) {
        // プールダウン内でのスクロール時
        height = listWrapperRect.height;
      } else {
        height = window.innerHeight;
      }

      if (
        scrollBottomTop > 0 &&
        height - this.margin >= scrollBottomTop &&
        !this.state.is_load
      ) {
        if (this.props.callback) {
          let notify;
          if (!this.props.ignoreIndicator) {
            this.setState({ is_load: true });
            notify = this.notifyEnd.bind(this);
          }
          this.props.callback(notify);
        }
      }
    }
  }

  // 親からの 通信終了通知 を受け取る
  notifyEnd(type) {
    this.setState({ is_load: false });

    // console.log('!!!!!! Load  End !!!!!!');

    if (type === 'end') {
      this.removeScrollEvent();
    }
  }

  //インジケーターとメッセージ
  getLoaderElement() {
    if (this.props.isLoading) {
      return <div className='indicator' />;
    }
    if (this.props.LoaderElement) {
      return this.props.LoaderElement({
        id: this.ID,
        is_load: this.state.is_load,
      });
    } else {
      let elem = [];
      if (
        this.props.total <= 0 &&
        !this.state.is_load &&
        !this.props.no_message
      ) {
        elem.push(
          <div id={this.ID} key={this.ID} className='table-has-no-data'>
            <div
              className={`table-has-no-data__message${
                this.props.largeMessageFlag ? '__large' : ''
              }`}
            >
              {this.props.no_data_message
                ? this.props.no_data_message
                : messageUtility.getMessage('I-000-046')}
            </div>
          </div>
        );
      } else if (this.props.total > 0 && this.state.is_load) {
        elem.push(<div key={this.ID} id={this.ID} className='indicator' />);
      } else {
        elem.push(<div key={this.ID} id={this.ID} />);
      }
      return elem;
    }
  }

  render() {
    return this.getLoaderElement();
  }
}



// WEBPACK FOOTER //
// ./src/components/InfinityScrollLoad.jsx